<template>
  <div class="pa-3 pa-sm-4 pa-md-5">
    <div class="d-flex align-center mb-4 mb-sm-5">
      <v-btn @click="$router.back()" class="back-btn">
        <v-icon left>mdi-arrow-left</v-icon>
        VOLVER
      </v-btn>
    </div>
    <br />
    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Gestión de Clientes"
        :Cabecera="Cabecera"
        :Items="Items"
        :Excel="true"
        :Crear="true"
        :Loading="Loading"
      />
    </v-col>
  </div>
</template>
<script>
import tabla from "@/components/cliente/tabla.vue";

import { mapGetters, mapActions, mapState } from "vuex";
export default {
  components: {
    tabla,
  },
  created() {
    const data = { menu: 1, submenu: 3 }; //Eliminar
    this.CargarMenu(data);
    this.cargarClientes();
    this.cargarSectores();
    console.log("RDX > created()");
  },
  data() {
    return {
      Cabecera: [
        {
          text: "Acción",
          value: "accion",
          align: "center",
          sortable: false,
          width: 100,
        },
        { text: "ID", value: "id", align: "center", width: 75 },
        { text: "Razón Social", value: "razon_social", align: "left" },
        { text: "RUC", value: "ruc", align: "left", width: 130 },
        { text: "Estado", value: "estado", align: "center", width: 120 },
        { text: "Logotipo", value: "ruta_logo", align: "center", width: 120 },
        {
          text: "Costo por Defecto",
          value: "costo",
          align: "center",
          width: 170,
        },
      ],
    };
  },
  methods: {
    ...mapActions("cliente", ["cargarClientes"]),
    ...mapActions("sector", ["cargarSectores"]),
    ...mapActions("nav", ["CargarMenu"]),
  },

  computed: {
    ...mapGetters("cliente", ["Items"]),
    ...mapState("cliente", ["Loading"]),
  },
};
</script>

<style scoped>
.back-btn {
  font-weight: 700;
  letter-spacing: 0.3px;
  border-radius: 8px;
  text-transform: none;
  transition: all 0.2s ease;
}

.back-btn:hover {
  transform: translateX(-2px);
}
</style>
